import React from 'react';
import { Navigate } from 'react-router-dom';
import { toast } from 'react-hot-toast';

export default function RoleRoute({ children, allowedRoles }) {
  const token = localStorage.getItem('token');
  const userStr = localStorage.getItem('user');
  const user = userStr ? JSON.parse(userStr) : null;

  if (!token || !user) {
    return <Navigate to="/login" replace />;
  }

  if (allowedRoles && !allowedRoles.includes(user.rol)) {
    toast.error('No tenes permisos para acceder a esta seccion');
    return <Navigate to="/" replace />;
  }

  return children;
}
